import { useQuery } from '@tanstack/react-query';

export type FeatureFlags = Record<string, boolean>;

const apiBase = () =>
  `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}`;

// Public endpoint: no auth header needed.
export const useFeatureFlags = () => {
  const query = useQuery<FeatureFlags>({
    queryKey: ['globalFeatureFlags'],

    queryFn: async () => {
      const response = await fetch(`${apiBase()}/global/feature-flags`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch feature flags');
      }
      return response.json();
    },

    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    retry: 1
  });

  return { flags: query.data, isLoading: query.isLoading };
};

// Convenience: returns true only when the flag is explicitly enabled.
// Defaults to false while loading or when the flag is unknown.
export const useFeatureFlag = (key: string): boolean => {
  const { flags } = useFeatureFlags();
  return flags?.[key] === true;
};
